const VirtualMachine = require('../../model/VirtualMachine');
const CredentialGroup = require('../../model/CredentialGroup');
const Authority = require('../../model/Authority');
const ProtectionGroup = require('../../model/Policy');
const TableState = require('../../model/TableState');
const Filter = require('../../../shared/ctxFiltersPanel/ctxFilterModel');
const RecoverVersion = require('../../model/RecoverVersion');
const Target = require('../../model/Target');
const { permissions } = require('../../constants/permissions');
const SERVER_API = 'api/v1/';

// const VM_ADMIN_ROLE = 'Tenant';
// get users by role name => VM_ADMIN_ROLE
// this.userTableState.filterBy = VM_ADMIN_ROLE;

class VirtualMachinesPersistenceService {
    constructor($filter, $rootScope, $q, crudService, sharedPersistenceService, utilsService, storageService, iamPersistenceService, config) {
        this._crudService = crudService;
        this._sharedPersistence = sharedPersistenceService;
        this._utilsService = utilsService;
        this._storageService = storageService;
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this._$q = $q;
        this.iamPersistenceService = iamPersistenceService;
        this.registryUrl = config.registryUrl;
        this.userTableState = new TableState();
        this.REST_ENDPOINTS = this._sharedPersistence.getRestEndpoints();
        this.groups = [];
        this.initFilter(true);
        this.searchKey = VirtualMachine.getSearchKey();

        this.$rootScope.$on("logout", () => {
            this.virtualMachinesTableState = undefined;
            this.clearFilter();
            this._storageService.clearCustomPageSize('vms');
        });
        this.$rootScope.$on("force-logout", () => {
            this.virtualMachinesTableState = undefined;
            this.clearFilter();
            this._storageService.clearCustomPageSize('vms');
        });
    }

    initFilter() {
        this.filters = [];
        this.backupFilters = [];
        this.filters.push(Filter.getSelectFilter(this.$filter('translate')('vm.filters.resourceGroups'), VirtualMachine.getResourceGroupsKey(), [], 'resourceGroups', true));
        this.filters.push(Filter.getSelectFilter(this.$filter('translate')('vm.filters.policies'), VirtualMachine.getPolicyKey(), [], 'policies', true));
        this.filters.push(Filter.getSelectFilter(this.$filter('translate')('vm.filters.credentials'), VirtualMachine.getCredentialsKey(), [], 'credential', true));
        this.filters.push(Filter.getCheckboxFilter(this.$filter('translate')('vm.filters.compliancy'), VirtualMachine.getCompliancyKey(), VirtualMachine.getCompliancyOptions(), 'compliancy'));
        this.filters.push(Filter.getCheckboxFilter(this.$filter('translate')('vm.filters.protected'), VirtualMachine.getStatusKey(), VirtualMachine.getStatusOptions(), 'protected'));
        this.filters.push(Filter.getCheckboxFilter(this.$filter('translate')('vm.filters.discovery'), VirtualMachine.getDiscoveryKey(), VirtualMachine.getDiscoveryOptions(), 'discovery'));

        //restore point filters
        this.backupFilters.push(Filter.getSelectFilter(this.$filter('translate')('vm.backups.filter.tiers'), 'backupType', RecoverVersion.getTierOptions(this.$filter('translate')), 'tier'));
        let timeFilter = Filter.getTimeFilter(this.$filter('translate')('vm.backups.filter.restorePointDate'), 'created', RecoverVersion.getTimeOptions(this.$filter('translate')), 'restore-date');
        timeFilter.datetimeLocaleFormat = this.datetimeLocaleFormat;
        this.backupFilters.push(timeFilter);
        this.backupFilters.push(Filter.getCheckboxFilter(this.$filter('translate')('tasks.filters.status'), 'status', [], 'status'));
        this.backupFilters.push(Filter.getCheckboxFilter(this.$filter('translate')('vm.backups.filter.compliancy'), 'compliancy', RecoverVersion.getCompliancyOptions(this.$filter('translate')), 'backup-compliancy'));

        //TODO TODO add checkbox to hide expired backups

        this.updateFilters();
    }


    initDropdownFilters() {
        let credentialsFilter, policyFilter, resourceGroupsFilter;

        this.getAllCredGroups().then(credentials => {
            credentialsFilter = this.filters.filter(item => item.filterKey === VirtualMachine.getCredentialsKey())[0];
            credentialsFilter.originalList = credentialsFilter.options = this.updateFilterOptions(credentials, credentialsFilter);
        });

        this.getAllResourceGroups().then(resourceGroups => {
            resourceGroupsFilter = this.filters.filter(item => item.filterKey === VirtualMachine.getResourceGroupsKey())[0];
            if (!resourceGroupsFilter) {
                this.filters.splice(1, 0, Filter.getSelectFilter(this.$filter('translate')('vm.filters.resourceGroups'), VirtualMachine.getResourceGroupsKey(), [], 'resourceGroups', true));
                resourceGroupsFilter = this.filters.filter(item => item.filterKey === VirtualMachine.getResourceGroupsKey())[0];
            }
            resourceGroupsFilter.originalList = resourceGroupsFilter.options = resourceGroups.map(
                (item, i) => {
                    return {
                        id: i,
                        label: item.label,
                        value: item.value
                    };
                });
        });

        this.getAllProtectionGroups().then(policies => {
            policyFilter = this.filters.filter(item => item.filterKey === VirtualMachine.getPolicyKey())[0];
            policyFilter.originalList = policyFilter.options = this.updateFilterOptions(policies, policyFilter);
        });
    }

    updateFilters() {
        let statusFilter;
        this.getStatusOptions().then((statusTypes) => {
            statusFilter = this.backupFilters.filter(item => item.filterKey === 'status')[0];
            if (!statusFilter) {
                this.backupFilters.splice(1, 0, Filter.getSelectFilter(this.$filter('translate')('event.filters.status'), 'status', [], 'status'));
                statusFilter = this.backupFilters.filter(item => item.filterKey === 'status')[0];
            }

            statusFilter.options = statusTypes;
        });
    }

    getStatusOptions() {
        return this._crudService.get('taskStatuses').then((res) => {
            return res.data.entities;
        });
    }

    updateFilterOptions(items, filterItem, key, customLabel) {
        let param = !key ? 'name' : key,
            selectedOptions = filterItem.selectedOptions ? filterItem.selectedOptions.map(item => item.value) : [];
        return items.map((item, i) => {
            return { id: i, label: item[customLabel ? customLabel : param], value: item[param], selected: selectedOptions.indexOf(item[param]) > -1 };
        });
    }

    clearFilter() {
        if (this.virtualMachinesTableState) this.virtualMachinesTableState.page = 1;
        this.filters.forEach((filter) => {
            filter.clear();
        });
        this.backupFilters.forEach((backupFilter) => {
            backupFilter.clear();
        });
    }

    getVirtualMachines(firstPage, filters, forceSync, isExport) {
        if (!this.iamPersistenceService.hasPermissions(permissions.VM_LISTING)) {
            return this._$q((resolve) => { resolve([]); });
        }

        if (firstPage && this.virtualMachinesTableState) {
            this.virtualMachinesTableState.page = 1;
        }
        if (!this.virtualMachinesTableState) {
            this.virtualMachinesTableState = new TableState();
            this.virtualMachinesTableState.orderBy = 'name';
            // check if custom pageSize is set
            let tempPageSize = this._storageService.getCustomPageSize('vms');
            if (tempPageSize) {
                this.virtualMachinesTableState.pageSize = tempPageSize;
            }
        }

        return this._crudService.getPagedWithStructuredFilter(this.REST_ENDPOINTS.VMS_REST, this.virtualMachinesTableState, filters, forceSync, VirtualMachine.getSearchKey(), null, isExport).then(res => {
            let searchBy = undefined;
            if (angular.isDefined(this.virtualMachinesTableState.searchBy)) {
                searchBy = this.virtualMachinesTableState.searchBy;
            }
            this.virtualMachinesTableState = res.data.tableState;
            this.virtualMachinesTableState.searchBy = searchBy;

            // set pageSize value
            if (this.virtualMachinesTableState && this.virtualMachinesTableState.pageSize) this._storageService.setCustomPageSize('vms', this.virtualMachinesTableState.pageSize);

            return res.data.entities.map(VirtualMachine.fromRaw);
        });
    }

    getVirtualMachine(vmName) {
        if (!this.iamPersistenceService.hasPermissions(permissions.VM_DETAILS)) {
            return this._$q((resolve) => { resolve([]); });
        }

        return this._crudService.get(`${this.REST_ENDPOINTS.VMS_REST}/${vmName}`).then(res => {
            return res.data.entities.map(VirtualMachine.fromRaw);
        });
    }

    getAllVirtualMachines(firstPage, filters, forceSync, isExport) {
        let tableState = new TableState();
        tableState.pageSize = 1000000;
        tableState.searchBy = this.virtualMachinesTableState.searchBy;
        return this._crudService.getPagedWithStructuredFilter(this.REST_ENDPOINTS.VMS_REST, tableState, this.filters, null, null, null, isExport).then(res => {
            return res.data.entities.map(VirtualMachine.fromRaw);
        });
    }

    getCredGroups(firstPage) {
        if (firstPage && this.credTableState) {
            this.credTableState.page = 1;
        }

        if (!this.credTableState) {
            this.credTableState = new TableState();
            this.credTableState.orderBy = 'name';
        }

        return this._crudService.getPaged(this.REST_ENDPOINTS.CREDENTIALS_REST, this.credTableState, null, null, null, 10, false).then(res => {
            this.credTableState = res.data.tableState;
            return res.data.entities.map(CredentialGroup.fromRaw);
        });
    }

    getCredGroup(cg) {
        return this._crudService.getById(this.REST_ENDPOINTS.CREDENTIALS_REST, cg.uuid).then(res => {
            return res.data.entities[0] ? CredentialGroup.fromRaw(res.data.entities[0]) : null;
        });
    }

    createCredGroup(cg) {
        return this._crudService.post(this.REST_ENDPOINTS.CREDENTIALS_REST, cg.toRaw());
    }

    updateCredGroup(cg) {
        return this._crudService.put(`${this.REST_ENDPOINTS.CREDENTIALS_REST}/${encodeURI(cg.uuid)}`, cg.toRaw());
    }

    deleteCredGroup(cg) {
        return this._crudService.del(`${this.REST_ENDPOINTS.CREDENTIALS_REST}/${encodeURI(cg.uuid)}`);
    }

    assignCredGroup(cg, payload) {
        return this._crudService.post(`${this.REST_ENDPOINTS.CREDENTIALS_REST}/${encodeURI(cg.uuid)}/assign`, payload);
    }

    unassignCredGroup(cg, payload) {
        return this._crudService.post(`${this.REST_ENDPOINTS.CREDENTIALS_REST}/unassign`, payload);
    }

    downloadPublicKey(uuid) {
        return this._crudService.get(`${this.REST_ENDPOINTS.CREDENTIALS_REST}/${encodeURI(uuid)}/downloadKey`).then(res => {
            return res.data.entities[0];
        });
    }

    getTargetById(id) {
        return this._crudService.get(`${this.REST_ENDPOINTS.TARGET_ENDPOINT}/${encodeURI(id)}`).then(res => res.data.entities[0], err => err);
    }

    getProtectionGroups(firstPage) {
        if (firstPage && this.protectionTableState) {
            this.protectionTableState.page = 1;
        }
        return this._crudService.getPaged(this.REST_ENDPOINTS.POLICY_REST, this.protectionTableState, null, null, null, 10).then(res => {
            this.protectionTableState = res.data.tableState;
            return res.data.entities.map(ProtectionGroup.fromRaw);
        });
    }

    getAllProtectionGroups() {
        return this._crudService.get(this.REST_ENDPOINTS.POLICY_REST).then(res => {
            return res.data.entities.map(ProtectionGroup.fromRaw);
        });
    }

    assignVirtualMachinePolicy(policy, payload) {
        return this._sharedPersistence.assignPolicy(policy, payload);
    }

    unassignVirtualMachinePolicy(policy, payload) {
        return this._sharedPersistence.unassignPolicy(policy, payload);
    }

    newCredGroup() {
        return new CredentialGroup();
    }

    getAllResourceGroups() {
        return this._crudService.get(this.REST_ENDPOINTS.RESOURCE_GROUP_REST + '/dropDown', null, null, null, null, null, null, false).then(res => {
            return res.data.entities;
        });
    }

    getAllCredGroups() {
        return this._crudService.get(this.REST_ENDPOINTS.CREDENTIALS_REST).then(res => {
            return res.data.entities.map(CredentialGroup.fromRaw);
        });
    }

    getAllVmAdminAuthorities() {
        return this._crudService.get(this.REST_ENDPOINTS.AUTHORITIES_REST + '/dropDown').then(res => {
            return res.data.entities.map(Authority.fromRaw);
        });
    }

    setVirtualMachineDetails(virtualMachine) {
        if (!this.iamPersistenceService.hasPermissions(permissions.VM_DETAILS)) {
            return this._$q((resolve) => { resolve([]); });
        }

        return this._crudService.get(`${this.REST_ENDPOINTS.VMS_REST}/${virtualMachine.uuid}`).then(details => details.data.entities[0], err => {
        });
    }

    getRestoredVirtualMachineDetails(virtualMachineUuid) {
        if (!this.iamPersistenceService.hasPermissions(permissions.VM_DETAILS)) {
            return this._$q((resolve) => { resolve([]); });
        }

        return this._crudService.get(`${this.REST_ENDPOINTS.VMS_REST}/getRestored/${virtualMachineUuid}`).then((details) => {
            return details.data.entities[0];
        });
    }

    showBackups(shownDetailsIndex, dateFilter, firstPage) {
        if (!this.iamPersistenceService.hasPermissions(permissions.VM_BACKUPS)) {
            return this._$q((resolve) => { resolve([]); });
        }

        if (firstPage && this.vmBackupTableState) {
            this.vmBackupTableState.page = 1;
        }
        return this._crudService.getPagedWithStructuredFilter(`${this.REST_ENDPOINTS.VMS_REST}/${shownDetailsIndex.id}/backups`, this.vmBackupTableState, this.backupFilters).then(versions => {
            this.vmBackupTableState = versions.data.tableState;
            let restorePoints = versions.data.entities.map(verRaw => {
                let ver = RecoverVersion.fromRaw(verRaw);
                ver.restorePoint = dateFilter(ver.restorePoint, 'shortSec');
                return ver;
            });
            restorePoints.forEach(rp => {
                rp.restorePointInMillis = dateFilter(rp.restorePointInMillis, 'shortSec');
                if (rp.backupTiers) {
                    rp.backupTiers.forEach(bt => {
                        bt.showTooltip = false;
                        bt.label = this.$filter('translate')('vm.subTable.detail.tagInfo.' + (bt.targetType === 'SNAPSHOT' ? bt.targetType.toLowerCase() : bt.backupType.toLowerCase()));
                        bt.smallerLabel = this.$filter('translate')('vm.subTable.detail.tagInfo.small.' + (bt.targetType === 'SNAPSHOT' ? bt.targetType.toLowerCase() : bt.backupType.toLowerCase()));
                        bt.tooltipLabel = this.$filter('translate')('vm.subTable.detail.tagInfo.tooltip.' + (bt.targetType === 'SNAPSHOT' ? bt.targetType.toLowerCase() : bt.backupType.toLowerCase()));
                        bt.class = (bt.label.indexOf('ARCH') > -1 ? 'arch' : bt.backupType.toLowerCase()) + (bt.state === 'EXPIRED' ? '-expired' : '');
                        bt.tagDot = bt.state !== 'DONE' && bt.state !== 'EXPIRED' && bt.state !== 'PENDING' ? ('partial-dot ' + bt.state.toLowerCase().replace(/_/g, '-')) : '';
                        bt.deletionTime = dateFilter(bt.deletionTime, 'shortSec');
                    });
                    rp.catalogStateDot = rp.catalogStatus && rp.catalogStatus !== 'DONE' && rp.catalogStatus !== 'EXPIRED' ? ('partial-dot ' + rp.catalogStatus.toLowerCase().replace(/_/g, '-')) : '';
                    this.maxNumOfTags = rp.backupTiers.length + (rp.catalogStatus ? 1 : 0) > this.maxNumOfTags ? rp.backupTiers.length + (rp.catalogStatus ? 1 : 0) : this.maxNumOfTags;
                }
            });
            return restorePoints;
        }, err => {
        });
    }

    deleteBackup(backupUuid, selectedTiers) {
        return this._sharedPersistence.expireBackup(backupUuid, selectedTiers);
    }

    getMaxNumberOfSnapshots() {
        return this._crudService.get(this.REST_ENDPOINTS.SNAPSHOT + '/maxSnapshotsInfo').then(res => {
            return res.data.entities[0];
        });
    }

    getExpectedNumberOfSnapshots(id) {
        return this._crudService.get(this.REST_ENDPOINTS.SNAPSHOT + '/expectedSnapshotNumber/' + encodeURI(id)).then(res => {
            return res.data.entities[0];
        });
    }

    getTargets(filterKey, filterValue) {
        return this._crudService.get(this.REST_ENDPOINTS.TARGET_ENDPOINT + (filterKey ? ('?filter=' + filterKey + encodeURIComponent('==') + filterValue) : '')).then(res => {
            return res.data.entities.map(Target.fromRaw);
        });
    }

    getTargetsFLR(filterKey, filterValue) {
        return this._crudService.get(this.REST_ENDPOINTS.TARGET_ENDPOINT_FLR + (filterKey ? ('?filter=' + filterKey + encodeURIComponent('==') + filterValue) : '')).then(res => {
            return res.data.entities;
        });
    }

    getLocations(managerUrl, subscriptionId) {
        if (managerUrl) {
            let url = managerUrl + SERVER_API + 'subscriptions/' + subscriptionId + '/locations';
            return this._crudService.get(url, null, null, null, null, true, true, true).then(res => {
                return res.data.entities;
            });
        }
        else {
            return this._crudService.get('locations', null, null, null, null, false, false, true).then(res => {
                return res.data.entities;
            });
        }
    }

    getAvailabilityZone(managerUrl, subscriptionId, locationUuid, virtualMachinesSizeUuid) {
        if (managerUrl) {
            let url = managerUrl + SERVER_API + 'subscriptions/' + subscriptionId + '/locations/' + locationUuid + '/virtualMachinesSizes/' + virtualMachinesSizeUuid + '/availabilityZones';
            return this._crudService.get(url, null, null, null, null, true, true, true).then(res => {
                this.availabilityZoneTableState = { searchBy: '' };
                return res.data.entities;
            });
        }
        else {
            return this._crudService.get('locations/' + locationUuid + '/virtualMachinesSizes/' + virtualMachinesSizeUuid + '/availabilityZones', null, null, null, null, false, false, true).then(res => {
                return res.data.entities;
            });
        }
    }

    getResourceGroups(managerUrl, subscriptionId) {
        if (managerUrl) {
            let url = managerUrl + SERVER_API + 'subscriptions/' + subscriptionId + '/resourceGroups/dropDown';
            return this._crudService.get(url, null, null, null, null, true, true, true).then(res => {
                return res.data.entities;
            });
        }
        else {
            return this._crudService.get('resourceGroups/dropDown', null, null, null, null, false, false, false).then(res => {
                return res.data.entities;
            });
        }
    }

    getResourceGroupsFromAzure(managerUrl, subscriptionId) {
        if (managerUrl) {
            let url = managerUrl + SERVER_API + 'subscriptions/' + subscriptionId + '/resourceGroups/azure/dropDown';
            return this._crudService.get(url, null, null, null, null, true, true, true).then(res => {
                return res.data.entities;
            });
        }
        else {
            return this._crudService.get('resourceGroups/azure/dropDown', null, null, null, null, false, false, true).then(res => {
                return res.data.entities;
            });
        }
    }

    getZones(managerUrl, subscriptionId, regionName) {
        if (managerUrl) {
            let url = managerUrl + SERVER_API + 'subscriptions/' + subscriptionId + '/regions/' + regionName + '/zones/dropDown';
            return this._crudService.get(url, null, null, null, null, true, true).then(res => {
                return res.data.entities;
            });
        }
        else {
            return this._crudService.get('zones/dropDown').then(res => {
                return res.data.entities;
            });
        }
    }

    getSubnets(managerUrl, subscriptionId, regionName) {
        if (managerUrl) {
            let url = managerUrl + SERVER_API + 'subscriptions/' + subscriptionId + '/virtualNetworks/subnets/dropDown?location=' + regionName;
            return this._crudService.get(url, null, null, null, null, true, true).then(res => {
                return res.data.entities;
            });
        }
        else {
            return this._crudService.get('virtualNetworks/subnets/dropDown?location=' + regionName).then(res => {
                return res.data.entities;
            });
        }
    }

    getInterfaces(managerUrl, subscriptionId, resourceGroup, regionName) {
        if (managerUrl) {
            let url = managerUrl + SERVER_API + 'subscriptions/' + subscriptionId + '/resourceGroup/' + resourceGroup + '/virtualNetworks/interfaces/dropDown?filter=location==' + regionName;
            return this._crudService.get(url, null, null, null, null, true, true).then(res => {
                return res.data.entities;
            });
        }
        else {
            return this._crudService.get('resourceGroups/' + resourceGroup + '/virtualNetworks/interfaces/dropDown?filter=location==' + regionName).then(res => {
                return res.data.entities;
            });
        }
    }

    getVirtualNetworks(managerUrl, subscriptionId, regionName) {
        if (managerUrl) {
            let url = managerUrl + SERVER_API + 'subscriptions/' + subscriptionId + '/virtualNetworks/azure?filter=location==' + regionName;
            return this._crudService.get(url, null, null, null, null, true, true, true).then(res => {
                return res.data.entities;
            });
        }
        else {
            return this._crudService.get('virtualNetworks/azure?filter=location==' + regionName, null, null, null, null, false, false, true).then(res => {
                return res.data.entities;
            });
        }
    }

    getVmNetwork(vmUuid) {
        return this._crudService.get(this.REST_ENDPOINTS.VMS_REST + `/${vmUuid}/network`, null, null, null, null, false, false, false).then(res => {
            return res.data.entities;
        });
    }

    getVirtualMachinesForDiskRestore(managerUrl, subscriptionId, resourceGroup, locationNameUuid, osType) {
        const protectionSetUuid = this._storageService.getProtectionSet().uuid;
        if (managerUrl) {
            let url = managerUrl + SERVER_API + 'subscriptions/' + subscriptionId + '/virtualMachines?pageSize=1000000&pageNumber=1&orderBy=name&filter=resourceGroup_name==' + resourceGroup.label + '&filter=location==' + regionName + '&filter=osType==' + osType;
            return this._crudService.get(url, null, null, null, null, true, true, true).then(res => {
                return res.data.entities;
            });
        } else {
            const managerUrl = this._storageService.getManagerHostname();
            return this._crudService.get(managerUrl + 'api/v1/subscriptions/' + subscriptionId + '/protectionSets/' + protectionSetUuid + '/virtualMachines' + '/resourceGroups/' + resourceGroup.value + '?pageSize=1000000&pageNumber=1&orderBy=name&filter=location_uuid==' + locationNameUuid + '&filter=osType==' + osType, null, null, null, null, false, true, false).then(res => {
                return res.data.entities;
            });
        }
    }

    getSubscription() {
        return this._crudService.get(this.registryUrl + SERVER_API + this.REST_ENDPOINTS.SCOPE_REST + '/subscriptions', false, false, false, false, true, true, true).then(res => {
            this.subscriptionTableState = { searchBy: '' };
            return res.data.entities[0].subscriptions;
        });
    }

    abortFLR(snapUuid) {
        let BROWSE_END_POINT = `restore/flr/${snapUuid}/abort`;

        return this._crudService.post(BROWSE_END_POINT, null, false, false, false, true);
    }

    restore(data) {
        return this._crudService.post('restore', data).then(res => {
            return res.data;
        });
    }

    validateRestore(data) {
        return this._crudService.post('restore/validate', data).then(res => {
            return res.data;
        });
    }

    getTasks() {
        return this._crudService.get(this.REST_ENDPOINTS.TASKS_REST).then(res => {
            return res.data.entities;
        });
    }

    abortTask(taskId) {
        return this._crudService.post(`${this.REST_ENDPOINTS.TASKS_REST}/${taskId}/abort`);
    }

    isFlr(vmName) {
        return this._crudService.get(this.REST_ENDPOINTS.VMS_REST + `/${vmName}/isflr`).then(res => {
            return res.data.entities[0];
        });
    }

    getVirtualMachineConfiguration(vmName) {
        return this._crudService.get(this.REST_ENDPOINTS.VMS_REST + `/${vmName}/configuration`).then(res => {
            return res.data.entities[0];
        });
    }

    getMultiVirtualMachineConfiguration(vmUuids) {
        return this._crudService.post(`${this.REST_ENDPOINTS.VMS_REST}/multiVmsConfiguration`, vmUuids).then(res => {
            return res.data;
        });
    }

    saveVirtualMachineConfiguration(vmName, data) {
        return this._crudService.put(this.REST_ENDPOINTS.VMS_REST + `/${vmName}/configuration`, data).then(res => {
            return res;
        });
    }

    saveMultiVirtualMachinesConfiguration(data) {
        return this._crudService.put(`${this.REST_ENDPOINTS.VMS_REST}/updateVmsConfigurations`, data).then((res) => {
            return res;
        });
    }

    getExternalAddresses(subscription, location, availabilityZone) {
        let url = subscription.managerEndpointUrl + SERVER_API + 'subscriptions/' + subscription.value + '/publicIPAddresses/azure?filter=availabilityZones==' + availabilityZone + '&filter=location==' + location;
        return this._crudService.get(url, null, null, null, null, true, true, true).then(res => {
            return res.data.entities;
        });
    }

}

VirtualMachinesPersistenceService.$inject = ['$filter', '$rootScope', '$q', 'crudService', 'sharedPersistenceService', 'utilsService', 'storageService', 'iamPersistenceService', 'config'];

module.exports = VirtualMachinesPersistenceService;



// WEBPACK FOOTER //
// ./src/azurebackup/views/virtualMachines/virtualMachines.persistence.service.js